<template>
  <div id={id} class={className}>
    <div class="pswp-thumbnails">
      <div class="c-activity-image-other c-company-images">
        <template :item="item" v-for="(item, index) in items" class="pswp-thumbnail">
          <template v-if="index < 4 && !(index == 2 && items.length == 3)"> 
            <a :key="index"  @click="showPhotoSwipe($event, index)" :class="index == 1 ? 'c-activity-image c-company-main' : 'c-activity-image'">
                <slot :item="item">
                    <img :src="item.src" alt="picture"/>
                </slot>
            </a>
          </template>
        </template>
      </div>
      <div class="c-activity-image-button">
        <a key="0" @click="showPhotoSwipe($event, 0)">
            {{trans('Show all')}}
        </a>
      </div>
    </div>
    <v-photoswipe
      ref="pswp"
      :isOpen="opened"
      :items="items"
      :options="options"
      @close="handleClose"
    />
  </div>
</template>

<script>
import { PhotoSwipe, events } from 'v-photoswipe'
export default {
  name: 'v-photoswipe-gallery',
  components: {
    'v-photoswipe': PhotoSwipe
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      default: {}
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      opened: this.isOpen,
      opts: {}
    }
  },
  watch: {
    isOpen (val, oldVal) {
      if (val !== this.opened) {
        this.opened = val
      }
    }
  },
  methods: {
    showPhotoSwipe (e, index) {
      e.preventDefault()
      this.opts = Object.assign(this.options, {
        index
      })
      this.opened = true
    },
    handleClose () {
      this.opened = false
    }
  },
  mounted () {
    events.forEach(e => {
      this.$refs.pswp.$on(e, (...args) => {
        args.unshift(this)
        this.$emit(e, [...args])
      })
    })
  }
}
</script>

<style lang="css">
  .pswp-thumbnails .pswp-thumbnail {
    font-size: 0;
    cursor: pointer;
  }
</style>